import React from 'react';
import BreadCrumbContainer from '../../../fragments/BreadCrumbContainer';
import BreadCrumb from '../../../fragments/BreadCrumb';
import SubHeader from '../../../fragments/SubHeader';
import { useNavigate } from 'react-router-dom';
import AddButton from '../../../fragments/Buttons/AddButton';

const SubHeaderFacturacion = ({ handleModal }) => {
  const navigate = useNavigate();
  return (
    <div className='flex align-middle justify-between'>
      <SubHeader>
        <BreadCrumbContainer>
          <BreadCrumb route={'Inicio /'} onClick={() => navigate(`/home`)} />
          <BreadCrumb route={'Facturación'} active />
        </BreadCrumbContainer>
      </SubHeader>
      <div className='py-5 px-10'>
        <AddButton text='Generar factura' onClick={() => handleModal()} />
      </div>
    </div>
  );
};

export default SubHeaderFacturacion;
